import { Children, cloneElement } from 'react';
import cn from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import { createBemBlockBuilder } from '@ebsco-ui/utils';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';

var TextControl = function TextControl(_ref) {
  var label = _ref.label,
      error = _ref.error,
      description = _ref.description,
      className = _ref.className,
      children = _ref.children,
      labelButton = _ref.labelButton;
  var getBlocksWith = createBemBlockBuilder(["eb-text-control", className]);
  var child = Children.only(children);
  var inputId;

  if (child.props.id) {
    inputId = child.props.id;
  } else {
    console.error("Please provide an id for your input. This is necessary to help describe the purpose of the control.");
  }

  var childWithClass = cloneElement(child, {
    className: cn(child.props.className, getBlocksWith("__control"))
  });
  return /*#__PURE__*/jsxs("div", {
    className: cn(getBlocksWith(), error && getBlocksWith("--invalid")),
    children: [/*#__PURE__*/jsxs("div", {
      className: getBlocksWith("__label-wrapper"),
      children: [/*#__PURE__*/jsx("label", {
        htmlFor: inputId,
        className: getBlocksWith("__label"),
        children: label
      }), labelButton]
    }), description && /*#__PURE__*/jsx("div", {
      "data-auto": "text-control-description",
      className: getBlocksWith("__description"),
      id: cn(inputId && "".concat(inputId, "-description")),
      children: description
    }), childWithClass, /*#__PURE__*/jsx("p", {
      className: getBlocksWith("__error"),
      id: cn(inputId && "".concat(inputId, "-error")),
      children: error && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(FontAwesomeIcon, {
          className: getBlocksWith("__error-icon"),
          icon: faExclamationCircle,
          "aria-hidden": "true"
        }), error]
      })
    })]
  });
};

export { TextControl as default };
//# sourceMappingURL=text-control-esm.js.map
